export enum DateFormats {
  DayMonthYearDot = 'dd.MM.yyyy', // 06.02.2026
  DayMonthYearDotShort = 'dd.MM.yy', // 06.02.26
  DayMonthYearDash = 'dd-MM-yyyy', // 06-02-2026
  IsoDate = 'yyyy-MM-dd', // 2026-02-06
  WeekdayFullDate = 'EEEE, dd.MM.yyyy', // czwartek, 06.02.2026
  WeekdayName = 'EEEE', // czwartek
  WeekdayShort = 'EEEEEE', // czw
  DayMonthDot = 'dd.MM', // 06.02
  DayMonthShort = 'd.M', // 6.2
  DayMonthNameLong = 'd MMMM', // 9 maja, 11 października
  DayMonthNameShort = 'd MMM', // 9 May, 13 Apr
  Time = 'HH:mm', // 15:20
  MonthYear = 'LLLL yyyy' // luty 2026
}
